export default "__VITE_ASSET__ClDdpDe7__"